import { DocsBlockLayout } from "./SDKDocsBlockLayout";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocsBlockVariant {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        this.id = model.id;
        this.name = model.name;
        this.image = (_a = model.image) !== null && _a !== void 0 ? _a : null;
        this.description = (_b = model.description) !== null && _b !== void 0 ? _b : null;
        this.documentationLink = (_c = model.documentationLink) !== null && _c !== void 0 ? _c : null;
        this.layout = new DocsBlockLayout(model.layout);
        this.maxColumns = (_d = model.maxColumns) !== null && _d !== void 0 ? _d : 1;
        this.defaultColumns = (_e = model.defaultColumns) !== null && _e !== void 0 ? _e : 1;
        this.appearance = {
            isBordered: (_g = (_f = model.appearance) === null || _f === void 0 ? void 0 : _f.isBordered) !== null && _g !== void 0 ? _g : undefined,
            hasBackground: (_j = (_h = model.appearance) === null || _h === void 0 ? void 0 : _h.hasBackground) !== null && _j !== void 0 ? _j : undefined,
            isEditorPresentationDifferent: (_l = (_k = model.appearance) === null || _k === void 0 ? void 0 : _k.isEditorPresentationDifferent) !== null && _l !== void 0 ? _l : undefined,
            showBlockHeaderInEditor: (_o = (_m = model.appearance) === null || _m === void 0 ? void 0 : _m.showBlockHeaderInEditor) !== null && _o !== void 0 ? _o : undefined,
        };
    }
}
